import script from "./RecTable.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./RecTable.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./RecTable.vue?vue&type=style&index=0&id=41628834&lang=scss"
import "./RecTable.vue?vue&type=style&index=1&id=41628834&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41628834"]])

export default __exports__